<template>
    <div>
        <div v-if="loading" class="flex justify-center items-center min-h-[200px]">
      <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-custom-yellow"></div>
    </div> 
    <template v-else>
        <div class="relative overflow-x-auto shadow-md sm:rounded-lg mt-5">
            <table class="w-full text-left rtl:text-right text-gray-700">
                <thead>
                    <tr class="bg-gray-100">
                        <th scope="col" class="p-4">
                            <div class="flex items-center">
                                <input id="checkbox-all-search" type="checkbox"
                                    class="w-4 h-4 text-custom-yellow bg-gray-100 border-gray-300 rounded focus:ring-custom-yellow dark:focus:ring-custom-yellow dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
                                <label for="checkbox-all-search" class="sr-only">checkbox</label>
                            </div>
                        </th>
                        <th scope="col" class="px-6">
                            <div class="flex items-center">
                                Donor Name
                                <a href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true"
                                        xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                                        <path
                                            d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                                    </svg></a>
                            </div>
                        </th>
                        <th scope="col" class="px-6">
                            <div class="flex items-center">
                                Deferred by
                                <a href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true"
                                        xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                                        <path
                                            d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                                    </svg></a>
                            </div>
                        </th>
                        <th scope="col" class="px-6">
                            <div class="flex items-center">
                                Deferral days
                                <a href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true"
                                        xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                                        <path
                                            d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                                    </svg></a>
                            </div>
                        </th>
                        <th scope="col" class="px-6">
                            <div class="flex items-center">
                                Deferral hours
                                <a href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true"
                                        xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                                        <path
                                            d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                                    </svg></a>
                            </div>
                        </th>
                        <th scope="col" class="px-6">
                            <div class="flex items-center">
                                Reason for Deferral
                                <a href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true"
                                        xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                                        <path
                                            d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                                    </svg></a>
                            </div>
                        </th>
                        <th scope="col" class="px-6">
                            <div class="flex items-center">
                                Date Deferred
                                <a href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true"
                                        xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                                        <path
                                            d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                                    </svg></a>
                            </div>
                        </th>
                        <th scope="col" class="px-6">
                            <div class="flex items-center">
                                Next Donation Date
                                <a href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true"
                                        xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                                        <path
                                            d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                                    </svg></a>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(deferrals, index) in filteredDonors" :key="index" class="border-b">
                        <td class="w-4 p-4">
                            <div class="flex items-center">
                                <input :id="'checkbox-table-search-' + index" type="checkbox" class="w-4 h-4">
                                <label :for="'checkbox-table-search-' + index" class="sr-only">checkbox</label>
                            </div>
                        </td>
                        <td class="px-6 py-2">{{ deferrals.user?.first_name }} {{
                            deferrals.user?.last_name }}</td>
                        <td class="px-6 py-2">
                            {{ deferrals.created_by ? `${deferrals.created_by.first_name}
                            ${deferrals.created_by.last_name}` : 'Unknown' }}
                        </td>
                        <td class="px-6 py-2">{{ deferrals.deferral_days }}</td>
                        <td class="px-6 py-2">{{ deferrals.deferral_hours }}</td>
                        <td class="px-6 py-2">{{ deferrals.deferral_reason }}</td>
                        <td class="px-6 py-2">{{ new Date(deferrals.created_at).toLocaleDateString('en-CA') }}
                        </td>
                        <td class="px-6 py-2">{{ deferrals.next_donation_date }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="flex justify-center gap-4 mt-4">
            <button disabled
                class="flex items-center gap-2 px-6 py-3 font-bold text-center text-custom-blue align-middle transition-all rounded-lg select-none hover:bg-custom-blue/10 active:bg-custom-blue/20 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
                type="button">
                <svg class="w-6 h-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                    fill="none" viewBox="0 0 24 24">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="m15 19-7-7 7-7" />
                </svg>
                Previous
            </button>
            <div class="flex items-center gap-2">
                <button
                    class="relative h-10 max-h-[40px] w-10 max-w-[40px] select-none rounded-lg bg-custom-blue text-center align-middle font-medium text-white shadow-md shadow-custom-blue/10 transition-all hover:shadow-lg hover:shadow-custom-blue/20 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
                    type="button">
                    <span class="absolute transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2">
                        1
                    </span>
                </button>
                <button
                    class="relative h-10 max-h-[40px] w-10 max-w-[40px] select-none rounded-lg text-center align-middle font-medium text-custom-blue transition-all hover:bg-custom-blue/10 active:bg-custom-blue/20 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
                    type="button">
                    <span class="absolute transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2">
                        2
                    </span>
                </button>
                <button
                    class="relative h-10 max-h-[40px] w-10 max-w-[40px] select-none rounded-lg text-center align-middle font-medium text-custom-blue transition-all hover:bg-custom-blue/10 active:bg-custom-blue/20 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
                    type="button">
                    <span class="absolute transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2">
                        3
                    </span>
                </button>
                <button
                    class="relative h-10 max-h-[40px] w-10 max-w-[40px] select-none rounded-lg text-center align-middle font-medium text-custom-blue transition-all hover:bg-custom-blue/10 active:bg-custom-blue/20 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
                    type="button">
                    <span class="absolute transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2">
                        4
                    </span>
                </button>
                <button
                    class="relative h-10 max-h-[40px] w-10 max-w-[40px] select-none rounded-lg text-center align-middle font-medium text-custom-blue transition-all hover:bg-custom-blue/10 active:bg-custom-blue/20 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
                    type="button">
                    <span class="absolute transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2">
                        5
                    </span>
                </button>
            </div>
            <button
                class="flex items-center gap-2 px-6 py-3 font-bold text-center text-custom-blue align-middle transition-all rounded-lg select-none hover:bg-custom-blue/10 active:bg-custom-blue/20 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
                type="button">
                Next
                <svg class="w-6 h-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                    fill="none" viewBox="0 0 24 24">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="m9 5 7 7-7 7" />
                </svg>
            </button>
        </div>
    </template>
    </div>
</template>

<script>
// import CustomButton from '@/components/CustomButton.vue';
import api from '@/services/api';

export default {
    name: 'DonorRegistryTab',
    components: {
        // CustomButton,
    },
    created() {
        this.fetchDonorDeferrals();
    },
    props: {
        searchQuery: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            deferrals: [],
            error: null,
            loading: false,
            filters: {
                dateRegistered: '',
                deferralDays: '',
                deferralReason: '',
                nextDonationDate: ''
            },
            facility_logo: ""
        }
    },

    mounted() {
        this.userData = this.$store.getters["auth/user"];
        this.facility_logo = this.userData.user_roles[0]?.facility_department?.facility?.logo;
    },

    computed: {
        filteredDonors() {
            return this.deferrals.filter(deferral => {
                const search = this.searchQuery.toLowerCase();
                const safeToLower = value => typeof value === 'string' ? value.toLowerCase() : '';

                // Apply search filter
                const matchesSearch =
                    safeToLower(deferral.user?.first_name).includes(search) ||
                    safeToLower(deferral.user?.last_name).includes(search) ||
                    safeToLower(deferral.deferral_reason).includes(search) ||
                    safeToLower(new Date(deferral.created_at).toLocaleDateString('en-CA')).includes(search);

                // Filter by dateRegistered
                const matchesDateRegistered = this.filters.dateRegistered === '' ||
                    new Date(deferral.created_at).toLocaleDateString('en-CA').includes(this.filters.dateRegistered);

                // Filter by deferralDays
                const matchesDeferralDays = this.filters.deferralDays === '' ||
                    deferral.deferral_days.toString() === this.filters.deferralDays;

                // Filter by deferralReason
                const matchesDeferralReason = this.filters.deferralReason === '' ||
                    safeToLower(deferral.deferral_reason).includes(safeToLower(this.filters.deferralReason));

                // Filter by nextDonationDate
                const matchesNextDonationDate = this.filters.nextDonationDate === '' ||
                    deferral.next_donation_date === this.filters.nextDonationDate;

                // Combine all filters
                return matchesSearch && matchesDateRegistered && matchesDeferralDays && matchesDeferralReason && matchesNextDonationDate;
            });
        }
    },

    methods: {

        async fetchDonorDeferrals() {
            this.loading = true
            try {
                const response = await api.getDonorDeferrals();
                this.deferrals = response.data || response;
                console.log('data:', this.deferrals);
            } catch (error) {
                this.error = error.message || 'Failed to fetch donors';
            } finally {
            this.loading = false;
            }
        },

        applyFilters(filters) {
            this.filters = { ...this.filters, ...filters };
        },

        resetFilters() {
            this.filters = {
                dateRegistered: '',
                deferralDays: '',
                deferralReason: '',
                nextDonationDate: ''
            };
        },

        async handleDownloadReactionReport() {
        const printWindow = document.createElement('iframe');
        printWindow.style.position = 'absolute';
        printWindow.style.width = '0';
        printWindow.style.height = '0';
        document.body.appendChild(printWindow);


        try {
          // Generate table content from filteredBloodProducts
          const queryParams = {
            search_date: this.dateRange,
            search_query: this.searchQuery,
            all: true
          };

          const response = await api.getDonorDeferrals(queryParams);
          const sample_data = response.data || response;

          const tableRows = sample_data.map((data, index) => `
        <tr class="border-b text-sm">
          <td class="px-3 py-1">${index + 1}</td>
          <td class="px-3 py-1">${data.user?.first_name} ${data.user?.last_name}</td>
          <td class="px-3 py-1">${data.created_by?.first_name} ${data.created_by?.last_name}</td>
          <td class="px-3 py-1">${data.deferral_days}</td>
          <td class="px-3 py-1">${new Date(data.created_at).toLocaleString()}</td>
        </tr>
      `).join('');


          // Prepare print content
          const printContent = `
        <div class="page-container">
          <div class="report-container">
            <div class="logo-container">
                <img src="${this.facility_logo}" alt="Hospital Logo" class="logo">
              </div>
            <br><br>
            <h1 class="text-lg font-bold mb-4">Deferrals List Report</h1>
            <p class="mb-4">Generated on: ${new Date().toLocaleString()}</p>
            
            <div class="table-container">
              <table class="w-full text-left">
                <thead>
                  <tr class="bg-gray-100">
                    <th class="px-6 py-2"></th>
                    <th class="px-6">Donor Name</th>
                    <th class="px-6 py-2">Defered By</th>
                    <th class="px-6">Deferral Days</th>
                    <th class="px-6">Date Deferred</th>
                  </tr>
                </thead>
                <tbody>
                  ${tableRows}
                </tbody>
              </table>
            </div>

            <div class="signatures mt-8">
              <div class="signature-line">
                <p>Prepared by: _________________</p>
                <p>Date: _________________</p>
              </div>
              <div class="signature-line mt-4">
                <p>Verified by: _________________</p>
                <p>Date: _________________</p>
              </div>
            </div>
          </div>
        </div>
      `;

          // Prepare the full document for printing
          const printDocument = `
        <html>
        <head>
          <title>Issued Units Report</title>
          <style>
            @media print {
              @page {
                size: A4;
                margin: 2cm;
              }
            }
            
            body {
              font-family: Arial, sans-serif;
              line-height: 1.6;
              color: #333;
              margin: 0;
              padding: 0;
            }
            .logo{
              width: 120px;
              float:right
            }

            .page-container {
              padding: 20px;
            }

            .report-container {
              max-width: 100%;
              margin: 0 auto;
            }

            table {
              width: 100%;
              border-collapse: collapse;
              margin-bottom: 20px;
              font-size: 10.5px;
            }

            th, td {
              border: 1px solid #ddd;
              padding: 8px;
              text-align: left;
            }

            th {
              background-color: #F3F4F6;
              font-weight: bold;
            }

            .signatures {
              margin-top: 40px;
              page-break-inside: avoid;
              font-size: 10.5px;
            }

            .signature-line {
              margin-bottom: 20px;
            }

            @media print {
              .status-badge {
                border: 1px solid #ddd;
              }
            }
          </style>
        </head>
        <body>
          ${printContent}
        </body>
        </html>
      `;

          // Open the print document
          printWindow.contentDocument.open();
          printWindow.contentDocument.write(printDocument);
          printWindow.contentDocument.close();

          // Print when the document is loaded
          printWindow.contentWindow.onload = function () {
            printWindow.contentWindow.print();
            // Remove the iframe after printing
            setTimeout(() => {
              document.body.removeChild(printWindow);
            }, 1000);
          };
        } catch (error) {
          console.error('Error generating report:', error);
        }
      },
    },
}
</script>

<style lang="css" scoped></style>